var map = {
	"./australia_a_league/banner.png": "jRtv",
	"./la_liga/banner.png": "5g48",
	"./premier_league/banner.png": "olzv",
	"./serie_a/banner.png": "BSji",
	"./wolves/banner.png": "L+LW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "se86";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/banner\.png$
// module id = se86
// module chunks = 1